import React from 'react';
import ModalCustom from "@ui/modal/ModalCustom";
import {useTranslation} from "react-i18next";
import ButtonCustom from "@ui/buttons/buttonCustom/ButtonCustom";
import FilePresentIcon from '@mui/icons-material/FilePresent';
import {IFileTaskSingleVoyage} from "@containers/singleVoyage/tasks/types";
import TasksFilesListSingleVoyage
    from "@containers/singleVoyage/tasks/tasksFiles/tasksFilesList/TasksFilesListSingleVoyage";
import IconButtonCustom from "@ui/buttons/iconButtonCustom/IconButtonCustom";

interface IProps {
    files: IFileTaskSingleVoyage[]
    btnVariant?:'icon' | 'text'
}

const TasksFilesListModalSingleVoyage = ({files,btnVariant}: IProps) => {
    const {t} = useTranslation()

    if(btnVariant === 'icon'){
        return (
            <ModalCustom
                initialFullScreenMode
                component={<TasksFilesListSingleVoyage
                    files={files}
                />}
                label={t('base.files')}
                button={<IconButtonCustom
                    size={'small'}
                    sx={{
                        fontSize:'12px'
                    }}
                    variant={'empty'}
                >
                    <FilePresentIcon
                        fontSize={'small'}/> ({files?.length})
                </IconButtonCustom>}
            />
        );
    }

    return (
        <ModalCustom
            initialFullScreenMode
            component={<TasksFilesListSingleVoyage
                files={files}
            />}
            label={t('base.files')}
            button={<ButtonCustom
                variant={'outlined'}
                startIcon={<FilePresentIcon/>}
                size={'small'}
            >
                {t('base.files')}({files?.length})
            </ButtonCustom>}
        />
    );
};

export default TasksFilesListModalSingleVoyage;